import axios from 'axios';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}


export default {
    edit(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tahun'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/targetcollection/edit${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    save(data) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("targetcollection", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    view(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tahun'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/targetcollection/view${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    viewprint(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tahun'];

                let str = '?';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const url = `/targetcollection/viewprint${str}`;
                const { data } = await axios.get(url);
                console.log('data : ', data);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    viewexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tahun'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                let response = await axios({
                    url: `/targetcollection/viewexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `targetcollection_${obj.tahun}.xlsx`);
                document.body.appendChild(link);
                link.click();
                resolve(link);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },
    actual(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tahun', 'tgl1', 'tgl2', 'layout'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/targetcollection/actual${str}`;
                const { data } = await axios.get(url);
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    actualexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['departkd', 'departemen', 'tahun', 'tgl1', 'tgl2', 'layout'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                let response = await axios({
                    url: `/targetcollection/actualexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `targetcollection_actual_${obj.tahun}.xlsx`);
                document.body.appendChild(link);
                link.click();
                resolve(link);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },
    actualytdexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['departkd', 'departemen', 'tahun', 'tgl1', 'tgl2', 'layout'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                let response = await axios({
                    url: `/targetcollection/actualytdexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `targetcollection_actual_${obj.tahun}.xlsx`);
                document.body.appendChild(link);
                link.click();
                resolve(link);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },

    detail(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'namaacc', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/targetcollection/detail${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    detailexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'namaacc', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/targetcollection/detailexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `collection_detail_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
};